// Auth Pages
import CreateAccount from 'pages/auth/create-account';
import SignIn from 'pages/auth/sign-in';
import ForgotPassword from 'pages/auth/forgot-password';
import ResetPassword from 'pages/auth/reset-password';
import Verify from 'pages/auth/verify';
import SetPassword from 'pages/auth/set-password';
// Nav Pages
import BodyData from 'pages/body-data/body-data';
import ProductMatches from 'pages/product-matches/product-matches';
import Sessions from 'pages/sessions/sessions';
// Other
import Landing from 'pages/landing/landing';
import Profile from 'pages/profile/profile';
import NotFound from 'pages/errors/not-found';
// Localization
import messages from './messages';
import i18n from 'src/i18n';

class RouteDescription {
    constructor({
        path,
        component,
        i18nKey,
        isPrivate = true,
        crawlable = true,
    }) {
        this.path = path;
        this.component = component;
        this.i18nKey = i18nKey;
        this.private = isPrivate;
        this.crawlable = crawlable;
    }

    localizedName() {
        return i18n.formatMessage(messages[this.i18nKey]);
    }
}

class RouteList {
    constructor() {
        this.nav = [
            new RouteDescription({
                path: '/',
                component: { public: Landing, private: BodyData },
                i18nKey: 'body_data_route_label',
                isPrivate: false,
            }),
            new RouteDescription({
                path: '/product-matches',
                component: ProductMatches,
                i18nKey: 'product_matches_route_label',
            }),
            new RouteDescription({
                path: '/sessions',
                component: Sessions,
                i18nKey: 'sessions_route_label',
            }),
            new RouteDescription({
                path: '/locations',
                component: () =>
                    (window.location.href =
                        'https://www.specialized.com/store-finder'),
                i18nKey: 'locations_route_label',
                isPrivate: false,
            }),
        ];

        this.other = [
            new RouteDescription({
                path: '/terms',
                // 'component': Terms,
                component: () =>
                    (window.location.href =
                        'https://www.specialized.com/terms-of-use'),
                i18nKey: 'terms_of_service_route_label',
                isPrivate: false,
            }),
            new RouteDescription({
                path: '/privacy-policy',
                // 'component': PrivacyPolicy,
                component: () =>
                    (window.location.href =
                        'https://www.specialized.com/privacy-policy'),
                i18nKey: 'privacy_policy_route_label',
                isPrivate: false,
            }),
            new RouteDescription({
                path: '/profile',
                component: Profile,
                i18nKey: 'account_profile_route_label',
                isPrivate: false,
            }),
            new RouteDescription({
                path: '/create-account',
                component: CreateAccount,
                i18nKey: 'create_account_route_label',
                isPrivate: false,
            }),
            new RouteDescription({
                path: '/sign-in',
                component: SignIn,
                i18nKey: 'sign_in_route_label',
                isPrivate: false,
            }),
            new RouteDescription({
                path: '/forgot-password',
                component: ForgotPassword,
                i18nKey: 'forgot_password_route_label',
                isPrivate: false,
            }),
            new RouteDescription({
                path: '/reset-password',
                component: ResetPassword,
                i18nKey: 'reset_password_route_label',
                isPrivate: false,
            }),
            new RouteDescription({
                path: '/set-password',
                component: SetPassword,
                i18nKey: 'set_password_route_label',
                isPrivate: false,
            }),
            new RouteDescription({
                path: '/verify',
                component: Verify,
                i18nKey: 'verify_route_label',
                isPrivate: false,
            }),
            new RouteDescription({
                path: '/*',
                component: NotFound,
                i18nKey: 'not_found_route_label',
                isPrivate: false,
                crawlable: false,
            }),
        ];

        this.all = [...this.nav, ...this.other];
        this.crawlable = this.all.filter((el) => el.crawlable);
    }
}

const routes = new RouteList();
export default routes;



// WEBPACK FOOTER //
// ./src/routes/routes.js